import { Injectable } from '@angular/core';
import { SelectOptionModel } from '../../src/typings/api';
import { ModbusDeviceConfigModel } from '../../src/typings/api.location';
import { ITypedResponse } from '../../src/typings/ITypedResponse';
import { IDeviceStatusListSummary } from '../../src/typings/models';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root',
})
export class ModbusService {
    static $name: string = 'modbusService';

    constructor(
        private proxyService: ProxyService,
    ) {
    }

    getModbusDevice(criteria: CASLink.Device.Ui.ViewModel.Modules.ModbusDeviceCriteriaViewModel) {
        return Promise.resolve<ModbusDeviceConfigModel>(
            this.proxyService.request({
                data: criteria,
                endPoint: 'modbusDeviceConfigs',
                route: 'getModbusDevice',
        }).as<ModbusDeviceConfigModel>());
    }

    saveModbusDevice(macAddress: string, model: ModbusDeviceConfigModel) {
        const requestData = {
            configuration: model,
            macAddress: macAddress
        };

        return Promise.resolve<ITypedResponse<ModbusDeviceConfigModel>>(
            this.proxyService.request({
                data: requestData,
                endPoint: 'modbusDevices',
                route: 'saveModbusDevice',
        }).as<ITypedResponse<ModbusDeviceConfigModel>>());
    }

    deleteModbusDevice(id: string, macAddress: string) {
        return Promise.resolve<boolean>(
            this.proxyService.request({
                data: { value: macAddress },
                endPoint: 'modbusDevices',
                route: 'deleteSelectedModbusDevice',
                routeParams: { id },
        }).as<boolean>());
    }

    getModuleDeviceVersions(category: string) {
        return Promise.resolve<SelectOptionModel[]>(
            this.proxyService.request({
                endPoint: 'modbusDevices',
                route: 'getModuleDeviceVersions',
                routeParams: {
                    category: category
                },
        }).asArray<SelectOptionModel>());
    }

    getModbusDeviceTemplateConfigurations(macAddress: string, category: string, version: number) {
        return Promise.resolve<ModbusDeviceConfigModel[]>(
            this.proxyService.request({
            endPoint: 'modbusDeviceConfigs',
            route: 'getModbusDeviceTemplateConfigurations',
            routeParams: {
                category: category,
                version: version
            },
            queryParams: {
                macAddress: macAddress,
            }
        }).asArray<ModbusDeviceConfigModel>());
    }

    updateConfigurations(
        macAddress: string,
        currentItem: IDeviceStatusListSummary,
        currentItemState: IDeviceStatusListSummary,
        newVersion: number) {
        if (currentItemState && newVersion !== currentItemState.hardwareVersion) {
            currentItem.configuration = null;
            currentItem.configurations = null;
            this.getModbusDeviceTemplateConfigurations(macAddress, currentItem.category, newVersion)
                .then(data => {
                    currentItem.configurations = data;
                });
        }
    }
}
